import React , {Component} from 'react';
import GamesImg from '../../assets/images/yoga.png';


export default class AllGamesPage extends Component{
    constructor(){
        super()
        this.state = {
            map_array:[1,2,3,4,5,6]
        }
    }
    render(){
        return(
            <div className="all-games-main">
            <div className="container-fluid">
            <div className="all-games-head">
            <h3>All Games</h3>
            </div>

            <div className="all-games-list">
            <div className="row">
{ this.state.map_array.length>0 ?
    this.state.map_array.map((item,i)=>(

    
            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
            <div className="all-games-list-div">
            <div className="all-games-list-image-div">
            <img src={GamesImg} alt='loading...'/>
            
            </div>
            <div className="all-games-list-content-div">
            <h6>Chess</h6>
            <p>Play chess against a computer</p>
            
            </div>
            
            </div>
            </div>
            ))
       :'' }
            
            
            </div>
            <div className="row">
            <div className="col-md-12 col-lg-12">
            <div className="all-games-list-lower-div">
            <h5>Looking for a game you don't see here ?</h5>
            <p>Let us know and we will do our best to make it available.</p>
            <button className="btn">Contact Kinship</button>
            </div>
            </div>
            
            </div>
            
            </div>

            </div>
            
            </div>
        )
    }
}

